import { InjectionToken } from '@angular/core';
import axios, { type AxiosInstance } from 'axios';
import { environment } from '../../../environments/environment';

/**
 * Shared axios instance for backend API calls only (not static assets or Okta URLs).
 * {@link appConfig} overrides this provider to attach Okta bearer tokens in production.
 */
export const AXIOS_INSTANCE = new InjectionToken<AxiosInstance>('AXIOS_INSTANCE', {
  providedIn: 'root',
  factory: () =>
    axios.create({
      baseURL: environment.apiBaseUrl,
      headers: {
        Accept: 'application/json',
      },
    }),
});
